
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'pinLabel': 'Fäst',
	'find_label': 'Sök',
	'findCancelLabel': 'Avbryt',
	'dataPaneLabel': 'Data',
	'sourcePaneLabel': 'Valda källor',
	'sourcePaneContentLabel': 'Välj en källa',
	'emptySourcePaneTitle': 'Välj en källa',
	'emptySourcePaneCaption': 'Klicka på Välj en källa om du vill lägga till data som ska användas till att bygga en kontrollpanel.',
	'addDataSource': 'Välj en källa',
	'addDataDashboardCoachMarkContents': 'Dra data från datapanelen till kontrollpanelen.',
	'addDataStoryCoachMarkContents': 'Dra data från datapanelen till berättelsen.',
	'addDataCoachMarkTitle': 'Lägg till data',
	'selectSourcesText': 'Välj och lägg till en datakälla för att bygga din %{app}.',
	'selectSourcesLabel': 'Välj en källa',
	'errorSourcesTitle': 'Det gick inte att läsa in dataträd',
	'errorLoadingDataSources': 'Fel vid inläsning av listan över datamängder.',
	'errorLoadingDataTree': 'Fel vid inläsning av trädet',
	'dataSetPaneLastUpdated': 'Uppdaterades senast: %{date}',
	'dataSourcePaneDateUnknown': 'Okänt',
	'moreTitle': 'Mer',
	'backLabel': 'Gå tillbaka',
	'addDataSourceDialogTitle': 'Välj en källa',
	'addDataSourceDialogButtonLabel': 'Lägg till',
	'dlg_use': 'Använd',
	'dlg_RelinkDataSourceTitle': 'Ersätt datamängden "%{dataSourceName}" med...',
	'propertiesDialogTitle': 'Egenskaper',
	'loadingMetadata': 'Läser in metadata',
	'missingDataSetData': 'Data för den här datamängden är inte tillgängliga. Uppdatera datamängden eller be administratören om åtkomst till källan.',
	'errorLoadingSource': 'Metadata för "%{sourceName}" lästes inte in. KOntakta administratören för mer information.',
	'errorMessageTitle': 'Fel',
	'calculation_navigation_in_use': 'Borttagning av beräkningar, filter eller navigeringsvägar ogiltigförklarar alla visualiseringar som refererar till det borttagna objektet. Vill du ta bort?',
	'delete_confirm': 'Bekräfta borttagning',
	'previewUnavailable': 'Datafack och globala filter är inte tillgängliga för den här pakettypen.',
	'contextualGridTabName': 'Visualiseringsdata',
	'DATA_TRAY_no_data_text': 'Du har för närvarande inga data',
	'contextualGridMenuLabel': 'Visualiseringsdatameny',
	'contextualGridExport': 'Exportera',
	'nullValueText': 'Null',
	'forecastDetailsTabName': 'Prognostiserar statistisk information',
	'forecastDetailsModelLabel': 'Modell',
	'forecastDetailsQualityMetricLabel': 'Noggrannhetsmått',
	'forecastDetailsSmoothingCoefLabel': 'Parametrar',
	'forecastDetailsDiagnostics': 'Felsökning',
	'forecastDetailsForecastLabel': 'Prognos',
	'forecastDetailsStatusLabel': 'Status',
	'forecastDetailsAccuracyPercentLabel': 'Precision %',
	'forecastDetailsTrendLabel': 'Trend',
	'forecastDetailsSeasonLabel': 'Säsongsvariation',
	'forecastDetailsSeasonalPeriodLabel': 'Säsongsperiod',
	'forecastDetailsAlphaLabel': 'Alfa',
	'forecastDetailsBetaLabel': 'Beta',
	'forecastDetailsGammaLabel': 'Gamma',
	'forecastDetailsPhiLabel': 'Phi',
	'forecastDetailsMissingCount': 'Felande antal',
	'forecastDetailsSeriesLengthLabel': 'Serielängd',
	'forecastDetailsIgnoredPeriods': 'Ignorerade perioder',
	'forecastDetailsTrendStrength': 'Trendstyrka',
	'forecastDetailsSeasonalityStrength': 'Säsongsstyrka',
	'forecastDetailsTimeDeltaUnit': 'Datum-/tidsintervall',
	'forecastDetailsNotes': 'Kommentarer'
});
